import { SvgInjector } from './modules/svgInjector';
import {Parallax}         from './modules/parallax';
import {ImagePopUp}       from './modules/imagePopUp';
import {Carousels}        from './modules/carousels';
import {MiniGallery}      from './modules/miniGallery';
import {DisplayNews}      from './modules/displayNews';
import {Cookies}          from './modules/cookies';
import {ResponsiveImages} from './modules/responsiveImages';
import {HamburgerMenu}    from './modules/hamburgerMenu';
import {ScrollTo}         from './modules/scrollTo';
import {GoogleMaps}       from './modules/googleMaps';
import {Video}            from './modules/video';
import {TabsSection}      from './modules/tabsSection';
import {Validator}        from './modules/validator';
import {SidePanel}        from './modules/sidePanel';
import {Navigation}        from './modules/navigation';
import {Submenu}        from './modules/submenu';
import {Visible}        from './modules/visible';
import { NewsletterSubscription } from './modules/newsletter';
import { Select2 } from './modules/select2';
import {CoverImage}        from './modules/coverImage';

var svgInjector       = new SvgInjector();
var parallax          = new Parallax();
var imagePopUp        = new ImagePopUp();
var carousels         = new Carousels();
var miniGallery       = new MiniGallery();
var displayNews       = new DisplayNews();
var cookies           = new Cookies();
var responsiveImages  = new ResponsiveImages();
var hamburgerMenu     = new HamburgerMenu();
var scrollTo          = new ScrollTo();
var googleMaps        = new GoogleMaps();
var video             = new Video();
var tabsSection       = new TabsSection();
var validator       = new Validator();
var sidePanel       = new SidePanel();
var navigation       = new Navigation();
var submenu       = new Submenu();
var visible       = new Visible();
var newsletterSubscription = new NewsletterSubscription();
var select2 = new Select2();
var coverImage       = new CoverImage();

class Main{
  constructor(node_env){
    this.node_env = node_env;
    this.sections = $('.cms-section');
    // jcf.setOptions('Select', {
    //   wrapNative: false,
    //   maxVisibleItems: 8
    // });
    // jcf.replaceAll();
  }
  bootstrap(callback){
    var $sections = $(this.sections);
    this.modules($sections);
    this.responsiveModules($sections);
    callback();
  }

  modules($sections){
    parallax.init($sections);
    svgInjector.init();
    imagePopUp.init();
    carousels.init();
    miniGallery.init();
    displayNews.init();
    cookies.init();
    responsiveImages.init($sections);
    hamburgerMenu.init();
    scrollTo.init();
    googleMaps.init();
    video.init();
    tabsSection.init();
    validator.init();
    sidePanel.init();
    navigation.init();
    submenu.init();
    visible.init();
    newsletterSubscription.init();
    select2.init();
    coverImage.init();
  }

  responsiveModules($sections){
    $(window).resize(function(){
      parallax.init($sections);
      carousels.init();
      miniGallery.init();
      displayNews.init();
      responsiveImages.init($sections);
    });

    $(window).scroll(function(){
      $('.video-player').each(function(id, videoPlayer){
        if( $(videoPlayer).visible(true) ){
          video.play($(videoPlayer));
        }else{
          video.stop($(videoPlayer));
        }
      });
    });
  }
}


$(window).load(function(){
    var main = new Main('development');
    main.bootstrap(function(){
        $('#page-overlay').fadeOut(800);
    });
});